import { fromJS, List } from 'immutable';
import * as reduxHelper from 'store/utils/reduxHelper';
import Value from 'models/GrowthPlan/Value';
import { byId } from 'store/utils/sortFunctions';
import types from './types';

export const initialState = fromJS({
  ...reduxHelper.applyReceiveInfo({
    data: {
      byId: {},
      byProject: {},
    },
    errorMessage: '',
    updatePending: false,
  }),
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.VALUES_LIST_SUCCEEDED:
      return state.merge(
        reduxHelper.applyRequestInfo({
          data: {
            byId: action.payload.results.reduce(
              (prevData, value) => prevData.set(value.id.toString(), new Value(value)).sort(byId),
              state.get('data').get('byId')
            ),
            byProject: state
              .get('data')
              .get('byProject')
              .set(
                String(action.payload.project),
                fromJS(action.payload.results.map(value => new Value(value))).sort(byId)
              ),
          },
        })
      );
    case types.VALUE_FETCH_SUCCEEDED:
    case types.VALUE_CREATE_SUCCEEDED:
    case types.VALUE_UPDATE_SUCCEEDED: {
      const projectId = String(action.payload.project);
      const projectValues = state
        .get('data')
        .get('byProject')
        .get(projectId, new List())
        .filter(value => value.id !== action.payload.id)
        .push(new Value(action.payload))
        .sort(byId);
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: false,
          data: {
            byId: state
              .get('data')
              .get('byId')
              .set(action.payload.id.toString(), new Value(action.payload)),
            byProject: state.get('data').get('byProject').set(projectId, projectValues),
          },
        })
      );
    }
    case types.VALUE_FETCH:
    case types.VALUE_CREATE:
    case types.VALUE_UPDATE:
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: true,
        })
      );
    case types.VALUE_DELETE_SUCCEEDED: {
      const projectId = String(action.payload.project);
      const projectValues = state
        .get('data')
        .get('byProject')
        .get(projectId, new List())
        .filter(value => value.id !== action.payload.id)
        .sort(byId);
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: false,
          data: {
            byId: state.get('data').get('byId').delete(action.payload.id.toString()),
            byProject: state.get('data').get('byProject').set(projectId, projectValues),
          },
        })
      );
    }
    case types.VALUE_UPDATE_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          updatePending: false,
          errorMessage: action.payload,
        })
      );
    case types.VALUE_CLEAR_ERROR:
      return state.merge(reduxHelper.applyReceiveInfo());
    case types.VALUE_FETCH_FAILED:
    case types.VALUES_LIST_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          errorMessage: action.payload,
        })
      );
    default:
      return state;
  }
}
